import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import WorkspacesOutlinedIcon from "@mui/icons-material/WorkspacesOutlined";
import { ProcessSibling } from "../../hooks/useProcessSiblings";

interface Props {
  siblings: ProcessSibling[];
  variant: "edit" | "review";
}

export const SharedBriefNotice: FC<Props> = ({ siblings, variant }) => {
  if (!siblings.length) return null;

  const count = siblings.length;
  const noun = count === 1 ? "project" : "projects";

  return (
    <Box className="flex items-start gap-3 rounded-md bg-primaryLight px-4 py-3">
      <WorkspacesOutlinedIcon
        sx={{ fontSize: 18, color: "#A58450", mt: "2px", flexShrink: 0 }}
      />
      <Box className="flex flex-col gap-1.5 min-w-0">
        <Typography className="!font-circular !text-[13px] !font-semibold !leading-tight !text-primary">
          Shared expert selection
        </Typography>
        <Typography className="!font-circular !text-[13px] !font-[450] !leading-[1.6] !text-dark1">
          {variant === "review"
            ? `Approving or denying this brief applies to ${count} other ${noun} in this order that share expert selection:`
            : `Saving or submitting updates this brief for ${count} other ${noun} in this order that share expert selection:`}
        </Typography>
        <Box className="flex flex-wrap gap-1.5">
          {siblings.map((project) => (
            <span
              key={project.id}
              className="rounded bg-white px-2 py-[3px] font-circular text-[12px] font-[450] text-darkgray1"
            >
              {project.title || `#${project.id}`}
            </span>
          ))}
        </Box>
      </Box>
    </Box>
  );
};
